import classnames from 'classnames';
import styles from '../card.module.scss';
import { resolveClassNames } from '../../../../helpers/classes';

export type CardBodyProps = {
  children: React.ReactNode;
  classString?: string | Array<string>;
  className?: string;
  noPadding?: boolean;
  style?: any; // contextStyle type,
  passedRef?: (ref?: HTMLDivElement | null | undefined) => void;
};

const CardBody = ({
  children,
  classString,
  className,
  style = { mobile: {} },
  noPadding,
  passedRef,
}: CardBodyProps) => (
  <div
    style={context.handleStyle(style)}
    className={classnames(
      styles.body,
      noPadding && styles['no-padding'],
      resolveClassNames(classString, styles),
      className,
    )}
    ref={passedRef ? ref => passedRef(ref) : null}
  >
    {children}
  </div>
);

export default CardBody;
